export const PermissionConstants = {
  DRIVER_DASHBOARD_VIEW: 'msfot:driver:dashboard:view',
  DRIVER_SEARCH_EXECUTE: 'msfot:driver:search:execute',
  DRIVER_CONFIGURE_EXECUTE: 'msfot:driver:configure:execute',
  DRIVER_CALCULATE_EXECUTE: 'msfot:driver:calculate:execute',
  DRIVER_ORDER_EXECUTE: 'msfot:driver:order:execute',
  DRIVER_ORDER_VIEW: 'msfot:driver:order:view',
  DRIVER_SELF_SERVICE_EXECUTE: 'msfot:driver:self-service:execute',
  DRIVER_CONFIGURE_VIEW: 'msfot:driver:configure:view',
  DRIVER_HOME_VIEW: 'msfot:driver:home:view',
  FLEETMANAGER_DASHBOARD_VIEW: 'msfot:fleetmanager:dashboard:view',
  FLEETMANAGER_RENTAL_VIEW: 'msfot:fleetmanager:rentaldashboard:view',
  FLEETMANAGER_CAR_POLICY_EDIT: 'msfot:fleetmanager:car-policy:edit',
  FLEETMANAGER_CAR_POLICY_VIEW: 'msfot:fleetmanager:car-policy:view',
  FLEETMANAGER_CREATEQUOTE_EXECUTE: 'msfot:fleetmanager:createquote:execute',
  FLEETMANAGER_SELF_SERVICE_EXECUTE: 'msfot:fleetmanager:self-service:execute',
  FLEETMANAGER_HOME_VIEW: 'msfot:fleetmanager:home:view',
  EMPLOYEE_CAR_POLICY_VIEW: 'msfot:employee:car-policy:view',
  EMPLOYEE_CAR_POLICY_EDIT: 'msfot:employee:car-policy:edit',
  EMPLOYEE_CREATE_QUOTE_EXECUTE: 'msfot:employee:createquote:execute',
  EMPLOYEE_ACCESS_MANAGEMENT_EXECUTE:
    'msfot:employee:access-management:execute',
  FINANCE_REPORTS_VIEW: 'msfot:finance:reports:view',
  CUSTOMER_REPORT_DAMAGE_EXECUTE: 'msfot:client:report-damage:execute',
  CUSTOMER_COMPANY_GUIDELINES_EXECUTE:
    'msfot:client:company-guidelines:execute',
  CUSTOMER_MULTI_FACTOR_AUTHENTICATION_REQUIRED:
    'msfot:client:multi-factor-authentication-required:execute',
  PERMISSION_CLIENT_QUOTE_APPROVAL_REQUIRED:
    'msfot:client:quote-approval-required:execute',
  FLEETMANAGER_ACCESS_APPROVAL: 'msfot:client:quote-approval-required:execute',
  INTERNATIONAL_FLEETMANAGER_DASHBOARD_VIEW:
    'msfot:fleetmanager:international-dashboard:view',
  FLEETMANAGER_E_INVOICE_VIEW: 'msfot:fleetmanager:einvoice:view',
  AGENT_DASHBOARD_VIEW: 'msfot:agent:dashboard:view',
  FLEETMANAGER_DOCUMENT_SEARCH_EXECUTE:
    'msfot:fleetmanager:document:search:execute',
  FLEETMANAGER_DOCUMENTS_VIEW: 'msfot:fleetmanager:documents:view',
}
